
import { gsap, Power1, Power4 , Power2, Power3} from "gsap";
$ = jQuery;

$("body").on("click", ".clickable[result]", function (e) {
    e.preventDefault();
    var id = $(this).attr("result");
    openOverlay("result", id);
});

$("body").on("click", ".overlay-close", function (e) {
    e.preventDefault();
    closeOverlay();
});

$(document).keyup(function (e) {
    if (e.key === "Escape") { // escape key maps to keycode `27`
        closeOverlay();
    }
});

export function openOverlay(type, id) {
    $("#nav").addClass("white");
    $(".overlay.hide").removeClass("hide");
    $("#page__content").addClass("blur");
    $(".logo").removeClass("show");
    $(".social-box").addClass("white");
    $(".phone-box").addClass("hide");
    $(".social-box").addClass("hide");
    var name = "res_" + id;
    var result = results[name];
    var video = result.video;
    $(".overlay h1").html('<span class="t0">' + result.title + '</span><span class="t1">' + result.title + '</span><span class="t2">' + result.title + '</span>');
    $(".overlay h4").html(result.hover_title);
    $(".overlay a.vimeo-link").attr({
        "href": result.vimeo_link
    });
    $(".overlay h4").after(htmlDecode(result.description));
    $(".overlay .credits").html(htmlDecode(result.credits));
    if (!mobileCheck()) {
        $(".overlay video").attr({
            "autoplay": "1"
        });
    }
    $(".overlay video").attr({
        "src": result.video.url,
        "controls": "1"
    });
    $(".overlay video").css({
        "background-image": "url(" + result.image + ")"
    });
    $(".overlay .media-items").css({
        "display": "none"
    });
    if (result.video_vertical == "1") {
        $(".overlay .content-box").addClass("vertical-video");
    }
    //console.log(result.overlay_gallery);
    if((result.overlay_gallery.length > 0) && (result.overlay_gallery[0].media !== false)){
        //console.log("append");
        $.each(result.overlay_gallery, function (i, media) {
            $(".overlay .media-items").css({
                "display": "grid"
            });
            //console.log(media.media.type);
            //if(media.media.type == )
            
            $(".overlay .media-items").append('<div class="item"><div class="img"><img src="' + media.media.sizes.large + '" alt="" /></div></div>');
        });
    }


}


export function closeOverlay() {
    $("#nav").removeClass("white");
    $(".overlay").addClass("hide");
    $("#page__content").removeClass("blur");
    $(".logo").addClass("show");
    $(".social-box").removeClass("white");
    $(".phone-box").removeClass("hide");
    $(".social-box").removeClass("hide");
    $(".overlay .content-box").removeClass("vertical-video");
    setTimeout(function () {
        $(".overlay h1, .overlay h4").empty();
        $(".overlay .text p").remove();
        $(".overlay video").attr({
            "src": ""
        });
        $(".overlay .media-items").empty();
        $(".overlay .credits").empty();
    }, 1000);
}



function htmlDecode(input) {
        var doc = new DOMParser().parseFromString(input, "text/html");
        return doc.documentElement.textContent;
    }